<template>
  <!-- Modal -->
  <div
    class="modal"
    id="delete-shirt"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Delete Shirt</h3>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12 mb-10">
              <div class="icheck-danger">
                <input
                  type="checkbox"
                  name="delete_consultant_system"
                  value="1"
                  id="deleteConsultantSystemCheck"
                />
                <label for="deleteConsultantSystemCheck"
                  >Delete this Shirt from the Consultant System as well?</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            CANCEL
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ disabled: isProcessing }"
            @click="deleteShirt()"
          >
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isProcessing: false,
    };
  },
  methods: {
    deleteShirt() {
      this.isProcessing = true;
      let check = $("#deleteConsultantSystemCheck").is(":checked");
      this.$emit("submit", check);
    },
    resetModal() {
      this.isProcessing = false;
    },
  },
};
</script>
